import { Icon } from '../ui';

const GROUPS = [
  {
    label: 'Günlük',
    items: [
      { id: 'orders', label: 'Siparişler', icon: 'orders' },
      { id: 'history', label: 'Geçmiş siparişler', icon: 'history' },
      { id: 'menu', label: 'Menü', icon: 'dish' },
      { id: 'dashboard', label: 'Satış özeti', icon: 'trend' },
    ],
  },
  {
    label: 'Pazarlama',
    items: [
      { id: 'campaigns', label: 'Kampanyalar', icon: 'tag' },
      { id: 'notifications', label: 'Bildirim gönder', icon: 'bell' },
    ],
  },
  {
    label: 'Ayarlar',
    items: [
      { id: 'zones', label: 'Teslimat bölgeleri', icon: 'map' },
      { id: 'settings', label: 'Restoran ayarları', icon: 'settings' },
    ],
  },
];

export const PAGE_TITLES = Object.fromEntries(GROUPS.flatMap((g) => g.items.map((i) => [i.id, i.label])));

function Sidebar({ activePage, onPageChange, totalBadge, isCancel, open }) {
  return (
    <aside className={`k-sidebar${open ? ' open' : ''}`}>
      <div className="k-brand">
        <img src="/kadihan-logo.jpg" alt="" />
        <div>
          <div className="k-brand-name">Kadıhan</div>
          <div className="k-brand-sub">Kebap &amp; Künefe</div>
        </div>
      </div>

      <nav className="k-nav" aria-label="Ana menü">
        {GROUPS.map((g) => (
          <div className="k-nav-group" key={g.label}>
            <div className="k-nav-label">{g.label}</div>
            {g.items.map((item) => {
              const active = activePage === item.id;
              const badge = item.id === 'orders' && totalBadge > 0 && !active;
              return (
                <button
                  key={item.id} type="button" className={`k-nav-item${active ? ' is-active' : ''}`}
                  onClick={() => onPageChange(item.id)} aria-current={active ? 'page' : undefined}
                >
                  <Icon name={item.icon} size={17} />
                  <span className="k-nav-text">{item.label}</span>
                  {badge && <span className={`k-nav-badge${isCancel ? ' is-cancel' : ''}`}>{totalBadge}</span>}
                </button>
              );
            })}
          </div>
        ))}
      </nav>

    </aside>
  );
}

export default Sidebar;
